module.exports = __webpack_public_path__ + "img/logo.dbdc0859.png";